
import { API } from '@/services/api.service'

export default {
  name: 'categories-index',

  head () {
    const title = this.$t('pages.allCategories.seo.metaTitle')
    const description = this.$t('pages.allCategories.seo.metaDescription')
    return {
      title,
      meta: [
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'twitter:title', name: 'twitter:title', content: title },

        { hid: 'description', name: 'description', content: description },
        { hid: 'og:description', property: 'og:description', content: description },
        { hid: 'twitter:description', name: 'twitter:description', content: description },

        // { hid: 'og:image', property: 'og:image', content: '' }, // TODO image
      ],
    }
  },

  jsonld () {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          position: 1,
          name: this.$t('breadcrumbs.home'),
          item: process.env.BASE_URL + this.localePath({ name: 'index' }),
        }, {
          '@type': 'ListItem',
          position: 2,
          name: this.$t('breadcrumbs.categories'),
          item: process.env.BASE_URL + this.localePath({ name: 'categories' }),
        },
      ]
    }
  },

  data() {
    return {
      categories: [],
    }
  },
  async asyncData({error}) {
    try {
      const {data} = await API.get(`/categories`)
      return {categories: data.categories}
    } catch (e) {
      error({statusCode: 500, message: 'Failed to load categories'})
    }
  },
}
